import { Box } from "@mui/material";
import React from "react";
import Plot from "react-plotly.js";

const ViolinBoxPlotChartComponent = ({
  data,
  title,
  yData,
  ranges,
  horizontal,
  height = "600px",
  width = "100%",
  pdf,
  bodyPercentage = [-1, 101],
}) => {
  const validYData = Array.isArray(yData)
    ? yData.filter((val) => val !== null && val !== undefined)
    : [];

  if (validYData?.length === 0 && pdf) {
    return <Box sx={{ width, height }}>No data available</Box>;
  }

  const patientIDs = data?.map((item) => `Patient ID: ${item.patient_id}`);

  const rangeCounts = ranges?.map(({ min, max }) => {
    return validYData?.filter((val) => val >= min && val <= max).length;
  });

  const violinData = {
    type: "violin",
    y: horizontal ? undefined : validYData,
    x: horizontal ? validYData : undefined,
    name: "Distribution",
    box: {
      visible: true,
      width: 0.4,
    },
    meanline: {
      visible: true,
    },
    points: "all",
    pointpos: -0.4,
    jitter: 0.4,
    fillcolor: "rgba(196, 147, 69, 0.5)",
    line: {
      color: "rgba(54, 34, 2, 0.5)",
    },
    spanmode: "manual",
    span: [0, 100],
    side: "positive",
    hoverinfo: "text",
    text: patientIDs,
  };

  const layout = {
    title: {
      text: title,
      font: {
        size: 16,
        weight: 600,
      },
    },
    xaxis: horizontal
      ? {
          range: horizontal ? [4, 15] : [1, 13],
          tick0: 0,
          dtick: horizontal ? 1 : 20,
          showgrid: true,
          zeroline: false,
          gridcolor: "rgba(200, 200, 200, 0.5)",
          gridwidth: 0.5,
        }
      : {
          range: [-0.25, 0.5],
          showgrid: false,
          zeroline: false,
          visible: false,
        },
    yaxis: horizontal
      ? {
          range: [-0.3, 0.8],
          showgrid: false,
          zeroline: false,
          visible: false,
        }
      : {
          range: bodyPercentage,
          tick0: 0,
          dtick: 20,
          showgrid: true,
          zeroline: true,
          gridcolor: "rgba(200, 200, 200, 0.5)",
          gridwidth: 0.5,
        },
    annotations: ranges?.map((range, index) => ({
      x: horizontal ? (range.max + range.min) / 2 : 1,
      y: horizontal ? 1 : (range.max + range.min) / 2,
      text: `<b>${rangeCounts[index]}<br>${range.label}</b>`,
      showarrow: false,
      font: {
        size: 14,
        color: "#000",
      },
      xref: horizontal ? "x" : "paper",
      yref: horizontal ? "paper" : "y",
      textangle: horizontal ? -90 : 0,
    })),

    shapes: ranges?.map((range, index) => ({
      type: "rect",
      xref: horizontal ? "x" : "paper",
      yref: horizontal ? "paper" : "y",
      x0: horizontal ? (index === 0 ? range.min : ranges[index - 1].max) : 0,
      x1: horizontal ? range.max : 1,
      y0: horizontal ? 0 : index === 0 ? range.min : ranges[index - 1].max,
      y1: horizontal ? 1 : range.max,
      fillcolor: range.color,
      opacity: 0.14,
      line: { width: 0 },
    })),

    margin: {
      l: 30,
      r: 15,
      b: 25,
      t: 60,
    },
    plot_bgcolor: "#FFFFFF",
    // paper_bgcolor: "#F7F7F7",
    showlegend: false,
    dragmode: false,
  };

  const config = {
    displayModeBar: false,
    responsive: true,
  };

  return (
    <Box
      sx={{
        width: "100%",
        margin: "0 auto",
        height: "100%",
      }}
    >
      <Plot
        data={[violinData]}
        layout={layout}
        config={config}
        style={{ width, height }}
      />
    </Box>
  );
};

export default ViolinBoxPlotChartComponent;
